import { Route } from "./routes";
import { globalNavigate } from "./use-global-navigate";

const navigateTo = (route: Route | string) => {
  globalNavigate(route);
};

export default navigateTo;
